if (!window.globoRelatedProductsEnhanceInit) {
  window.globoRelatedProductsEnhanceInit = true;

  (function () {
    var PREFECTURES = [
      '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '東京都', '神奈川県', '埼玉県',
      '千葉県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県',
      '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
      '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県',
      '佐賀県', '長崎県', '熊本県',
    ];

    var PREV_BUTTON_HTML =
      '<span class="btn__text"> <svg class="icon icon-caret-left rtl-flip-x icon--medium icon--thick" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '  <path d="M12.5 16.25L6.25 10L12.5 3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
      '</svg>\n' +
      '</span>';

    var NEXT_BUTTON_HTML =
      '<span class="btn__text"> <svg class="icon icon-caret-right rtl-flip-x icon--medium icon--thick " viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '  <path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
      '</svg>\n' +
      '</span>';

    var BOTTOM_TAG_BADGES = {
      数量限定: 'limited-quantity',
      期間限定: 'limited-time',
      メディア紹介: 'media',
      人気商品: 'popular',
      のし可: 'noshi',
      eギフト: 'egift',
      からだ想い: 'karadaomoi',
      こととやオリジナル: 'original',
    };

    function normalizeTag(tag) {
      return (tag || '').toString().trim().toLowerCase();
    }

    function matchesTagList(tag, list) {
      if (!list || !list.length) return false;
      var normalized = normalizeTag(tag);
      return list.some(function (item) {
        return normalizeTag(item) === normalized;
      });
    }

    function buildTopBadgeHtml(product) {
      var badgeTags = (window.FoxTheme && window.FoxTheme.productBadgeTags) || {};
      var html = '';

      if (product.available === false) {
        var soldOutLabel = (window.FoxTheme.variantStrings && window.FoxTheme.variantStrings.soldOut) || 'Sold out';
        html += '<span class="f-badge f-badge--soldout" aria-hidden="true">' + escapeHtml(soldOutLabel) + '</span>';
        return html ? '<div class="product-card__badge top">' + html + '</div>' : '';
      }

      (product.tags || []).forEach(function (tag) {
        if (matchesTagList(tag, badgeTags.newTags)) {
          html += '<span class="f-badge f-badge--new">' + escapeHtml(tag) + '</span>';
        } else if (matchesTagList(tag, badgeTags.hotTags)) {
          html += '<span class="f-badge f-badge--hot">' + escapeHtml(tag) + '</span>';
        } else if (matchesTagList(tag, badgeTags.comingTags)) {
          html += '<span class="f-badge f-badge--coming">' + escapeHtml(tag) + '</span>';
        }
      });

      var restockLabel = badgeTags.restockLabel || '再入荷';
      if((product.tags || []).indexOf(restockLabel) !== -1) {
        html += '<span class="f-badge f-badge--restock" aria-hidden="true">' + escapeHtml(restockLabel) + '</span>';
      }

      var bulkLabel = badgeTags.bulkLabel || 'まとめ買いがお得';
      if((product.tags || []).indexOf(bulkLabel) !== -1) {
        html += '<span class="f-badge f-badge--bulk" aria-hidden="true">' + escapeHtml(bulkLabel) + '</span>';
      }

      if (product.compare_at_price && product.price && product.compare_at_price > product.price) {
        var saleLabel = badgeTags.saleLabel || 'Sale';
        html += '<span class="f-badge f-badge--sale" aria-hidden="true">' + escapeHtml(saleLabel) + '</span>';
      }

      return html ? '<div class="product-card__badge top">' + html + '</div>' : '';
    }

    function buildBottomBadgeHtml(product) {
      var html = '';
      var tags = product.tags || [];

      Object.keys(BOTTOM_TAG_BADGES).forEach(function (tag) {
        if (tags.indexOf(tag) !== -1) {
          html += '<span class="f-badge f-badge--' + BOTTOM_TAG_BADGES[tag] + '" aria-hidden="true">' + escapeHtml(tag) + '</span>';
        }
      });

      tags.forEach(function (tag) {
        if (PREFECTURES.indexOf(tag) !== -1) {
          html += '<span class="f-badge f-badge--local" aria-hidden="true">' + escapeHtml(tag) + '</span>';
        }
      });

      tags.forEach(function (tag) {
        if (tag.indexOf('label_') === 0) {
          html += '<span class="f-badge" aria-hidden="true">' + escapeHtml(tag.slice('label_'.length)) + '</span>';
        }
      });

      return html ? '<div class="product-card__badge bottom">' + html + '</div>' : '';
    }

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    }

    function enhanceCard(card) {
      if (card.dataset.badgeEnhanced) return;
      card.dataset.badgeEnhanced = 'true';

      var link = card.querySelector('.spf-product-card__image-wrapper[href]');
      var info = card.querySelector('.spf-product__info');
      var inner = card.querySelector('.spf-product-card__inner');
      if (!link || !info || !inner) return;

      var handleUrl = link.getAttribute('href').split('?')[0];

      fetch(handleUrl + '.js')
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (!product) return;

          var topHtml = buildTopBadgeHtml(product);
          if (topHtml) {
            inner.insertAdjacentHTML('afterbegin', topHtml);
          }

          var bottomHtml = buildBottomBadgeHtml(product);
          if (bottomHtml) {
            info.insertAdjacentHTML('afterbegin', bottomHtml);
          }
        })
        .catch(function () {});
    }

    function scanForCards(root) {
      var cards = root.querySelectorAll('.globo-related-products .spf-product-card:not([data-badge-enhanced])');
      cards.forEach(enhanceCard);
    }

    // Owl Carousel computes each item's inline width from its own internal
    // margin setting, then applies that same margin as inline margin-right.
    // Overriding margin-right via CSS alone desyncs the width/position math,
    // so instead we keep the original (width + margin) step constant and
    // shift the difference into the width, re-applying this whenever Owl
    // recalculates and resets the inline styles (e.g. on resize/refresh).
  
    function scanOwlItems(root) {
      var items = root.querySelectorAll('.globo-related-products .owl-item');
    }

    function fixOwlNavWrapper(root) {
      root.querySelectorAll('.globo-related-products .owl-nav:not([data-nav-enhanced])').forEach(function (nav) {
        nav.dataset.navEnhanced = 'true';
        nav.className =
          'owl-nav swiper-controls swiper-controls--nav-floating swiper-controls--pagination-progressbar hidden md:flex lg:flex';
      });
    }

    function fixOwlNavButtons(root) {
      root.querySelectorAll('.globo-related-products .owl-prev:not([data-nav-enhanced])').forEach(function (btn) {
        btn.dataset.navEnhanced = 'true';
        btn.className = 'owl-prev swiper-button swiper-button--drop-shadow swiper-button-prev btn swiper-button-disabled';
        btn.setAttribute('name', 'previous');
        btn.setAttribute('aria-label', '左にスライド');
        btn.innerHTML = PREV_BUTTON_HTML;
      });
      root.querySelectorAll('.globo-related-products .owl-next:not([data-nav-enhanced])').forEach(function (btn) {
        btn.dataset.navEnhanced = 'true';
        btn.className = 'owl-next swiper-button swiper-button--drop-shadow swiper-button-next btn';
        btn.setAttribute('name', 'next');
        btn.setAttribute('aria-label', '右にスライド');
        btn.innerHTML = NEXT_BUTTON_HTML;
      });
    }

    function init() {
      scanForCards(document);
      scanOwlItems(document);
      fixOwlNavWrapper(document);
      fixOwlNavButtons(document);

      var scanScheduled = false;
      function scheduleScan() {
        if (scanScheduled) return;
        scanScheduled = true;
        requestAnimationFrame(function () {
          scanScheduled = false;
          scanForCards(document);
          scanOwlItems(document);
          fixOwlNavWrapper(document);
          fixOwlNavButtons(document);
        });
      }

      var observer = new MutationObserver(scheduleScan);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style'],
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
}
